module.exports = __webpack_public_path__ + "eaf89f307a380c7196855f3902559bf7.svg";